import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Graph, Item, Itens, Pf } from '../../models/itens.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ItensService } from '../../services/itens.service';
import { ItensFullResolverId, ItensResolverId } from '../../resolver/itens.resolver';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReuniaoCanDeactivate } from '../../reuniao-can-deactivate';

@Component({
  selector: 'app-itens-edit',
  templateUrl: './itens-edit.component.html',
  styleUrls: ['./itens-edit.component.scss']
})
export class ItensEditComponent extends BaseFormComponent<Itens> implements OnInit,ReuniaoCanDeactivate {

  id:number;
  itensData: Itens;
  showTrue: boolean = true;
  showFalse: boolean = true;
  itensLoad: number = 0;
  modalRef?: BsModalRef;
  cancelModal: boolean = false;
  edited: boolean = false;
  

  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ItensService,
    public itensResolverId: ItensResolverId,
    public itensFullResolverId: ItensFullResolverId,
    private navigation: NavigationService,
    private modalService: BsModalService,
    private router: Router
  ) {
    super(activatedRoute);
   }

  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.initForm();
    this.start();
  }
  
  
  canDeactivate(): boolean {
    if ( !this.cancelModal) {
      this.cancelModal = true;
      return !this.edited;
    }
    else{
      return true;
    }
  }

  start(){
    if(this.id && this.id != 0){
      this.itensResolverId.getById( this.id ).subscribe({
        next: (data) => {
          var newData = {...data, items: data.items.map(d=>({...d,'loading':true}))};
          this.entity = newData;
          this.itensData = newData;
          this.initForm();
          this.loaded();
          this.itensLoad = data.items.length;
          data.items.forEach((a,i) => {
            this.itensFullResolverId.getFullById(this.id, a.agency.id).subscribe({
              next: (dataFull) => {
                var newData =  {...a, ...dataFull,'loading':false };
                this.entity.items[i] = newData;
                this.itensData.items[i] = newData;
                this.updateForm(i,newData);
                this.itensLoad-- ; 
                //this.form.get("items")[i].patchValue(this.entity);
                //this.initForm();
              },
              error: (error) => {
                this.loaded();
                this.msgError(error.error.message);
              }
            })
          })
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error.message);
        }
      })
    }
    else{
      this.loaded();
    }
  }

  updateForm(i:number, data: object){
    const itemsFormArray = this.form.get('items') as FormArray;
    const itemsFormGroup = itemsFormArray.at(i) as FormGroup;
    itemsFormGroup.setControl('acPf', this.setData(data)); 
    itemsFormArray.at(i).patchValue(data);
    this.checkStatus(itemsFormGroup, false);
    itemsFormArray.markAsPristine();
  }

  initForm() {
    this.form = new FormGroup({
      items: this.createDataFormArray()
    });
    if (this.entity) {
      this.form.patchValue(this.entity);
    }
  }
  createDataFormArray(){
    if (!this.entity) {
      return new FormArray([new FormControl(null)]);
    }
    return new FormArray(this.entity.items?.map(item => 
      new FormGroup({
        acPf: this.setData(item),
        checkeds: new FormControl({ value: item.checkeds, disabled: true }),
        agency: new FormControl(item.agency),
        canSeeConfig: new FormControl(item.canSeeConfig)
      })
    ))
  }
  setData(data:any){
    var acMeetingType =  this.entity?.acMeetingType;
    return new FormArray( data.acPf?.map(i => 
      new FormGroup({
        id:new FormControl(i.id),
        checkeds:  new FormControl({ value: i.checkeds, disabled: acMeetingType == 3}),
        checkedsId: new FormControl(i.checkedsId),
        pfIndicators: new FormArray( i?.pfIndicators?.map(pfi => 
          new FormGroup({
            id:new FormControl(pfi.id),
            checkeds: new FormControl(pfi?.ac_meeting_pf_indicator? true : false),
            checkedsId: new FormControl(pfi?.ac_meeting_pf_indicator?.id),
            criticals: new FormArray( pfi?.pf_ind_critical?.map(clc =>
              new FormGroup({
                id:new FormControl(clc.id),
                checkeds: new FormControl(clc?.ac_meeting_pf_ind_critical? true : false),
                checkedsId: new FormControl(clc.ac_meeting_pf_ind_critical?.id),
                actions:new FormArray( clc?.pf_ind_action?.map(crt => 
                  new FormGroup({
                    id:new FormControl(crt.id),
                    checkeds: new FormControl(crt?.ac_meeting_pf_ind_action? true : false),
                    checkedsId: new FormControl(crt.ac_meeting_pf_ind_action?.id),
                  })) ?? []),
              })
            )),
            actions:new FormArray( pfi?.pf_ind_action_not_deleted?.map(and => 
              new FormGroup({
                id:new FormControl(and.id),
                checkeds: new FormControl(and?.ac_meeting_pf_ind_action? true : false),
                checkedsId: new FormControl(and.ac_meeting_pf_ind_action?.id),
              })) ?? [])
          })) ?? []),
      })) ?? []);
  }

  getDataCreate() {
    return Object.assign({}, this.form.getRawValue());
  }

  checkStatus(itemForm:FormGroup,change:boolean = false) {
    const anyChecked = itemForm.getRawValue()['acPf'].some(it => it.checkeds === true);
    itemForm.get("checkeds").setValue(anyChecked);
    console.log(change)
    if(change){
      itemForm.markAsDirty();
      this.edited = true;
    }
  }
  
  changeAllCheck(item: FormGroup, status: boolean){
    item.get("checkeds").setValue(status);
    const subArray = item.get('acPf') as FormArray;
    subArray.controls.forEach(it => {
        it.get("checkeds").setValue(status);
        const indArray = it.get('pfIndicators') as FormArray;
        indArray.controls.forEach(ind => 
          ind.get("checkeds").setValue(status)
        )
    });
    subArray.markAsDirty();
    this.edited = true;
  }
  
  restartCheck(item: FormGroup, i:number){
    var currentData = this.entity?.items[i]?.acPf;
    const subArray = item.get('acPf') as FormArray;
    var acPfValue = false;
    subArray.controls.forEach(it => {
      var indicatorValue = false;
      var currentValue = currentData.find(item => item.id === it.get("id").value);
      const indArray = it.get('pfIndicators') as FormArray;
      indArray.controls.forEach(ind => {
        var indicator = currentValue?.pfIndicators?.find(item => item.id === ind.get("id").value);
        var value = indicator?.meeting_indicator? true : false;
        ind.get("checkeds").reset(value);
        if(value) {
          indicatorValue = true;
        }
      })
      it.get("checkeds").reset(indicatorValue);
      if(indicatorValue) {
        acPfValue = true;
      }
    });
    item.get("checkeds").reset(acPfValue); 
  }

  filterData(){
    this.loading();
    var newData:Item[] = [];
    this.entity?.items?.forEach( item => {
      if(this.verifyCheck(item) == true){
        var newData2:Item = item;
        item.acIndicators?.forEach(it => {
          if(this.verifyCheck(it) == true){
            newData2['acIndicators'].push(it);
          }
        });
        item.acProjects?.map(it => {
          if(this.verifyCheck(it) == true){
            newData2['acProjects'].push(it);
          }
        });
        item.acCommitments?.map(it => {
          if(this.verifyCheck(it) == true){
            newData2['acCommitments'].push(it);
          }
        });
        item.acPf?.map(it => {
          if(this.verifyCheck(it) == true){
            var newData3:Pf = it;
            it.pfIndicators?.forEach(i => {
              if(this.verifyCheck(i) == true){
                newData3['pfIndicators'].push(i);
              }
            });
            newData2['acPf'].push();
          }
        });
        newData.push(newData2);
      }
      return null;
    });
    this.itensData = {...this.entity, items: newData};
    this.loaded();
  }

  verifyCheck(data:any){
    if(this.showTrue == true && data.checkeds == true){
      return true;
    }
    if(this.showFalse == true && (data.checkeds == false || !('checkeds' in data) || data.checkeds == null)){
      return true;
    }
    return false;
  }

  trackById(index: number, item: any): number {
    return item.id; 
  }

  getFormArray(fields:string[], ids:number[] = null): FormArray {
    if(this.entity){
      var item = null;
      fields.forEach((f,i)=>{
        if(!item){
          item = this.form.get(f) as FormArray;
        }
        else{
          item = item.controls[ids[i-1]]?.get(f) as FormArray;
        }
      })
      return item;
    }
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      var newData = this.getDataCreate();
      this.myService.update(newData,this.id ).subscribe({
        next: (res) => {
          this.msgSuccess('Itens alterados com sucesso!');
          //fazer o reload para o item clonado com modo EDITAR
          this.loaded();
        },
        error: (error) => {
          this.msgError(error.error.message);
          this.loaded();
        },
      });
    }
    else {
      this.markAsDirty();
    }
  }
  
  voltar() {
    this.navigation.back([`reuniao/reunioes`]);
  }
  
  openModal() {
    this.modalRef = this.modalService.show(this.modal,{class:'modal-m'});
  }

  closeModal() {
    this.modalRef?.hide();
  }

  
  //detecta o ctrl+s, evita que o navegador faça o evento padrão e chama a função de salvar
  @HostListener('document:keydown.control.s', ['$event'])
  onCtrlS(event: KeyboardEvent): void {
    event.preventDefault(); 
    this.salvar();
  }
  //detecta se o formulário está manipulado e se  pessoa está atualizando a página ou saindo dela.
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: BeforeUnloadEvent): void {
    if (this.edited && !this.cancelModal) {
      event.preventDefault();
      this.cancelModal = true;
    }
  }
}
